import { Box, Typography, useMediaQuery } from '@material-ui/core';
import { createStyles, makeStyles, Theme, useTheme } from '@material-ui/core/styles';
import React from 'react';
import { useAppSelector } from '../reduxhooks';

// Store footer. A tenant may upload a full-width footer image (svg/jpg/png)
// in Pengaturan; when set it replaces the generated text footer entirely,
// mirroring how fareast's footer worked. The mobile variant is optional and
// falls back to the desktop image.
//
// The image is rendered via <img> rather than inlined — tenant-uploaded SVG
// is served from the storefront origin, and an inlined <svg> would execute
// any script it carries. Inside <img> it cannot.
const useStyles = makeStyles((theme: Theme) =>
createStyles({
  footer: {
    width: '100%',
    backgroundColor: '#e9e9e9',
    color: '#262626',
    padding: '48px 0px 32px',
    marginTop: '60px',
  },
  inner: {
    width: '86%',
    margin: '0 auto',
  },
  storeName: {
    fontSize: '20px',
    fontWeight: 700,
    letterSpacing: '1px',
    marginBottom: '12px',
  },
  contactLine: {
    fontSize: '13px',
    fontWeight: 300,
    lineHeight: 1.9,
    color: '#262626',
  },
  credit: {
    fontSize: '11px',
    fontWeight: 300,
    color: '#262626',
    marginTop: '28px',
  },
  footerImage: {
    width: '100%',
    display: 'block',
  },
}));

export default function StoreFooter() {
  const classes = useStyles();
  const theme = useTheme();
  const isMdOrUp = useMediaQuery(theme.breakpoints.up('md'));
  const profile = useAppSelector(state => state.storeProfile.profile);

  // Image footer wins when configured. Mobile falls back to the desktop
  // image so a tenant only has to upload one to get a working footer.
  const desktopFooter = profile?.config?.footerImageUrl;
  const mobileFooter = profile?.config?.footerImageMobileUrl;
  const footerImage = isMdOrUp ? desktopFooter : (mobileFooter || desktopFooter);
  if (footerImage) {
    return (
      <img className={classes.footerImage} src={footerImage}
        alt={`Footer ${profile?.name ?? ''}`.trim()} />
    );
  }

  const contact = (profile?.config?.contact ?? {}) as {
    email?: string; phone?: string; whatsapp?: string; address?: string;
  };

  return (
    <Box className={classes.footer}>
      <Box className={classes.inner}>
        <Typography className={classes.storeName}>
          {profile?.name ?? ''}
        </Typography>
        {contact.address && <Typography className={classes.contactLine}>{contact.address}</Typography>}
        {contact.email && <Typography className={classes.contactLine}>{contact.email}</Typography>}
        {(contact.whatsapp || contact.phone) &&
          <Typography className={classes.contactLine}>
            {contact.whatsapp ? `WhatsApp: ${contact.whatsapp}` : contact.phone}
          </Typography>}
        <Typography className={classes.credit}>
          Didukung oleh Terbebas.ai
        </Typography>
      </Box>
    </Box>
  );
}
